import React from "react";
import { useTranslation } from "react-i18next";

const ConfirmDialog = ({ isOpen, title = "Confirm", message = "Are you sure?", onConfirm, onCancel }) => {
    const { t } = useTranslation();
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" dir={t('dir')}>
            <div className="bg-white rounded-lg shadow-lg max-w-sm w-full p-6 mx-2">
                <h3 className="text-lg font-semibold mb-4">{title}</h3>
                <p className="mb-6">{message}</p>
                <div className="flex justify-end gap-2" dir={t('dir')}>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700"
                    >
                        {t('yes')}
                    </button>
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
                    >
                        {t('no')}
                    </button>
                </div>
            </div>
        </div>
    );
}
export default ConfirmDialog;